import { Contract, ethers } from "ethers";
import { getNftByURI } from "../apiFunctions";
import { getDecimals } from "../ethereumFunctions";

const MY_NFT = require("./MY_NFT.json");
const NFT_SHARING = require("./NFT_SHARING.json");
const NFT_SHARE_TOKEN = require("./NFT_SHARE_TOKEN.json");
const ERC20 = require("../build/ERC20.json");

export async function tradeMyNFT(
  tokenAddress,
  amount,
  nftContract,
  nftId,
  contractAddress,
  signer,
  callback
) {
  const token = new Contract(tokenAddress, ERC20.abi, signer);

  const tokenDecimals = await getDecimals(token);

  const amountIn = ethers.utils.parseUnits(amount, tokenDecimals);

  const myNFT = new Contract(nftContract, MY_NFT.abi, signer);

  const nftAllowance = await myNFT.getApproved(nftId);

  if (nftAllowance === "0x0000000000000000000000000000000000000000") {
    await myNFT.approve(contractAddress, nftId);
  }

  let allowanceInterval = setInterval(async () => {
    const nft_allowance = await myNFT.getApproved(nftId);

    if (nft_allowance == contractAddress) {
      clearInterval(allowanceInterval);

      const nftSharing = new Contract(contractAddress, NFT_SHARING.abi, signer);

      await nftSharing
        .depositNft(nftContract, nftId, { value: amountIn })
        .then(() => {
          callback({ status: true });
        })
        .catch((e) => {
          callback({ status: false, e });
        });
    }
  }, 5000);
}

export async function getNFTContractCount(contractAddress, signer) {
  const contract = new Contract(contractAddress, NFT_SHARING.abi, signer);

  const total = await contract.getContractsCount();

  return +total;
}

export async function getNFTShareToken(contractAddress, signer, index) {
  const contract = new Contract(contractAddress, NFT_SHARING.abi, signer);

  const address = await contract.nftShareTokens(index);

  return address;
}

export async function getNFTInfo(contractAddress, accountAddress, signer) {
  const shareContract = new Contract(
    contractAddress,
    NFT_SHARE_TOKEN.abi,
    signer
  );

  const nftAddress = await shareContract.nftAddress();

  const nftId = await shareContract.nftId();

  const nftName = await shareContract.name();

  const bigBalance = await shareContract.balanceOf(accountAddress);

  const balance = +ethers.utils.formatUnits(bigBalance, 6);

  const finalNftEthPrice = await shareContract.getFinalNftEthPrice();

  const finalNftPricePerShare = await shareContract.finalNftPricePerShare();

  const maticBalance = (bigBalance * finalNftPricePerShare) / 10 ** 18;

  const nftContract = new Contract(nftAddress, MY_NFT.abi, signer);

  const isFinished = await shareContract.isFinished();

  const uri = await nftContract.tokenURI(+nftId);

  const nftInfo = await getNftByURI(uri);

  let content = {
    nftName,
    nftAddress,
    nftId: +nftId,
    uri,
    isFinished,
    finalNftEthPrice: +ethers.utils.formatUnits(finalNftEthPrice, 18),
    finalNftPricePerShare: +finalNftPricePerShare,
    balance: balance,
    maticBalance,
  };

  if (nftInfo) {
    content.nftInfo = nftInfo;
    return content;
  }
  return content;
}

export async function redeemNFT(tokenAddress, amount, contractAddress, signer) {
  const token = new Contract(tokenAddress, ERC20.abi, signer);

  const tokenDecimals = await getDecimals(token);

  const amountIn = ethers.utils.parseUnits(amount, tokenDecimals);

  const shareContract = new Contract(
    contractAddress,
    NFT_SHARE_TOKEN.abi,
    signer
  );

  await shareContract.redeemNft({ value: amountIn });
}

export async function redeemShare(contractAddress, signer) {
  const shareContract = new Contract(
    contractAddress,
    NFT_SHARE_TOKEN.abi,
    signer
  );

  await shareContract.redeemShare({ value: 0 });
}

export async function getShareNFTDetail(contractAddress, signer) {
  const contract = new Contract(contractAddress, NFT_SHARING.abi, signer);

  const feeTokenAmount = await contract.feeTokenAmount();

  const initLiquidityTokenAmount = await contract.initLiquidityTokenAmount();

  const minLiquidityEthAmount = await contract.minLiquidityEthAmount();

  return {
    feeTokenAmount: +ethers.utils.formatUnits(feeTokenAmount, 6),
    initLiquidityTokenAmount: +ethers.utils.formatUnits(
      initLiquidityTokenAmount,
      6
    ),
    minLiquidityEthAmount: +ethers.utils.formatUnits(minLiquidityEthAmount, 18),
  };
}
